import React, {Component} from 'react';
import './PrimaryButton.css';

/**
 * Giant call to action button usually used in a side pane on a profile page etc.
 */
class PrimaryButton extends Component {
	render() {
		const {className, onClick, icon = 'person_add', children, disabled} = this.props;

		return (
			<div className={`PrimaryButton ${className || ''}`}>
				<button
					className={`PrimaryButton-button ${disabled ? 'disable-button' : ''}`}
					onClick={onClick}
					disabled={disabled}>
					<span className={`icon icon-${icon}`} />
					<span>{children}</span>
				</button>
			</div>
		);
	}
}

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/widgets/PrimaryButton.js